import { Components } from "@thisgorilla/primate-ds";
import { FlexColumn } from "../../../../Common/Styles";

export const ExistingPods = () => {
  return (
    <FlexColumn $gapInPx={0}>
      <Components.ListItem
        type="List Item"
        onClick={() => {}}
        label="Product Designers Cape Town"
        iconType="Users"
        count="5"
        countColor="Primary"
      />
      <Components.ListItem
        type="List Item"
        onClick={() => {}}
        label="ZA Tech"
        iconType="Users"
        count="5"
        countColor="Primary"
      />
      <Components.ListItem
        type="List Item"
        onClick={() => {}}
        label="Founders Squad Cape Town"
        iconType="Users"
      />
    </FlexColumn>
  );
};
